import { useGetContext } from '@api/lendingAPI/lapiHooks';
import { fetchGetOnlineAccount } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { getBanksFromContext } from './getBanksFromContext';
import { getLinkedAccounts } from './getLinkedAccounts';
import { useStateKey } from '../../../iwQueryClient/useStateKey';

export const useGetLinkedAccounts = () => {
    const stateKey = useStateKey();
    const { data: onlineAccountsResponse } = useQuery({
        queryKey: ['online_accounts', stateKey],
        queryFn: () => fetchGetOnlineAccount({ stateKey })
    });
    const { data: context } = useGetContext();

    return getLinkedAccounts(
        onlineAccountsResponse,
        getBanksFromContext(context)
    );
};
